module.exports = __webpack_public_path__ + "static/media/branding_img_left.bd1342e7.png";